import { Text } from '@consumidor-positivo/aurora';
import { OrderByFilter } from '../../../types';

import { itemsList } from './data';
import './styles.scss';
import classNames from 'classnames';
type OrderFiltersProps = {
  selectedOrder: OrderByFilter;
  benefitFilter: string;
  onChangeOrder: (order: OrderByFilter) => void;
};
export const OrderFilters = ({ selectedOrder, onChangeOrder, benefitFilter }: OrderFiltersProps) => {
  return (
    <div className="mm-order-filters">
      <Text as="span" variant="body-small" color="secondary">
        Ordenar por:
      </Text>
      <div className="mm-order-filters__list">
        {itemsList
          .filter((item) => item.showOnBenefit === 'all' || item.showOnBenefit === benefitFilter)
          .map((item) => {
            const itemClass = classNames('mm-order-filters__item', {
              'mm-order-filters__item--selected': selectedOrder === item.slug,
            });
            return (
              <div key={`order-filter-${item.slug}`} className={itemClass} onClick={() => onChangeOrder(item.slug)}>
                {item.icon(selectedOrder === item.slug)}
                <Text as="span" variant="body-small" weight="semibold" color="secondary">
                  {item.label}
                </Text>
              </div>
            );
          })}
      </div>
    </div>
  );
};
